export default {

    BREADCRUMBS: ['configurator'],

    showPrices: false,

    image: '',

    loading: true,

    summary: [],

    inputField: {
        isFormValid: false,
    },

    BATHTUB: {

        // W_BREITE: {
        //     Code:         'W_BREITE',
        //     CurrentValue: '60',
        // },
        // W_LAENGE: {
        //     Code:         'W_LAENGE',
        //     CurrentValue: '165',
        // },
        // BREITE: {
        //     Code:         'BREITE',
        //     CurrentValue: '60',
        //     LowerLimit:   '60',
        //     UpperLimit:   '72',
        // },
        // LAENGE: {
        //     Code:         'LAENGE',
        //     CurrentValue: '165',
        //     LowerLimit:   '155',
        //     UpperLimit:   '167',
        // },
        Z23_switch: {
            Code:         'Z23_switch',
            CurrentValue: '0',
        },
        Z23_activator: {
            Code:         'Z23_activator',
            CurrentValue: '0',
        },
        Z67_switch: {
            Code:         'Z67_switch',
            CurrentValue: '0',
        },
        Z67_activator: {
            Code:         'Z67_activator',
            CurrentValue: '0',
        },
        Z45_switch: {
            Code:         'Z45_switch',
            CurrentValue: '0',
        },
        Z45_activator: {
            Code:         'Z45_activator',
            CurrentValue: '0',
        },
        Z81_switch: {
            Code:         'Z81_switch',
            CurrentValue: '0',
        },
        Z81_activator: {
            Code:         'Z81_activator',
            CurrentValue: '0',
        },
        default_options: [
            {
            Code:        'Position',
            Description: '',
            },
        ],
        MISSING_options: [
            {
                Description: ['kein', 'sans', 'without', 'senza'],
                Code:        '00',
            },
            {
                Description: ['Einlochmischer', 'Robinet mitigeur monotrou', 'Mono Faucet', ''],
                Code:        'L1',
            },
            {
                Description: ['Rundloch in Badewannenrand',  'Baignoire avec un rond trou',  '', ''],
                Code:        'L2',
            },
            {
                Description: ['Lochbohrung für Armatur nach Mass' , 'Percer le trou...', 'Drill hole for fitting to measure', ''],
                Code:        'AT',
            },
        ],
        lochbohrungen_select: {
            Code:         'lochbohrungen_select',
            CurrentValue: '0',
        },
        MISSING_WHIRLSYSTEM: {
            Code:         'MISSING_WHIRLSYSTEM',
            CurrentValue: '0',
        },
        MISSING_SOUNDSYSTEM: {
            Code:         'MISSING_SOUNDSYSTEM',
            CurrentValue: '0',
        },
        VAR_ABM: {
            Code:         'VAR_ABM',
            CurrentValue: '0',
        },
        SP_activator: {
            Code:         'SP_activator',
            CurrentValue: '0'
        },
        ALG_activator: {
            Code:         'ALG_activator',
            CurrentValue: '0'
        },
        SPS_T: {
            Code:         'SPS_T',
            CurrentValue: ''
        },
        GR_activator: {
            Code:         'GR_activator',
            CurrentValue: '0'
        },
        EA12: {
            Values: {
                Value: []
            }
        },
        EA34: {
            Values: {
                Value: []
            }
        },
        EA56: {
            Values: {
                Value: []
            }
        },
        EA78: {
            Values: {
                Value: []
            }
        },
        PGRUPPE: {
            Code: 'PGRUPPE',
            CurrentValue: 'BW',
        },
        SB: {
            Code: 'SB',
            CurrentValue: '0',
        },
    },

    DWDF: {
        // W_BREITE: {
        //     Code:         'W_BREITE',
        //     CurrentValue: '165',
        // },
        // W_LAENGE: {
        //     Code:         'W_LAENGE',
        //     CurrentValue: '60',
        // },
        BREITE: {
            Code:         'BREITE',
            CurrentValue: '65',
            LowerLimit:   '60',
            UpperLimit:   '72',
        },
        LAENGE: {
            Code:         'LAENGE',
            CurrentValue: '70',
            LowerLimit:   '155',
            UpperLimit:   '167',
        },
        Z23_switch: {
            Code:         'Z23_switch',
            CurrentValue: '0',
        },
        Z23_activator: {
            Code:         'Z23_activator',
            CurrentValue: '0',
        },
        Z67_switch: {
            Code:         'Z67_switch',
            CurrentValue: '0',
        },
        Z67_activator: {
            Code:         'Z67_activator',
            CurrentValue: '0',
        },
        Z45_switch: {
            Code:         'Z45_switch',
            CurrentValue: '0',
        },
        Z45_activator: {
            Code:         'Z45_activator',
            CurrentValue: '0',
        },
        Z81_switch: {
            Code:         'Z81_switch',
            CurrentValue: '0',
        },
        Z81_activator: {
            Code:         'Z81_activator',
            CurrentValue: '0',
        },
        S23_switch: {
            Code:         'S23_switch',
            CurrentValue: '0',
        },
        S23_activator: {
            Code:         'S23_activator',
            CurrentValue: '0',
        },
        S23: {
            Code:         'S23',
            CurrentValue: '0',
        },
        S67_switch: {
            Code:         'S67_switch',
            CurrentValue: '0',
        },
        S67_activator: {
            Code:         'S67_activator',
            CurrentValue: '0',
        },
        S67: {
            Code:         'S67',
            CurrentValue: '0',
        },
        S45_switch: {
            Code:         'S45_switch',
            CurrentValue: '0',
        },
        S45_activator: {
            Code:         'S45_activator',
            CurrentValue: '0',
        },
        S45: {
            Code:         'S45',
            CurrentValue: '0',
        },
        S81_switch: {
            Code:         'S81_switch',
            CurrentValue: '0',
        },
        S81_activator: {
            Code:         'S81_activator',
            CurrentValue: '0',
        },
        S81: {
            Code:         'S81',
            CurrentValue: '0',
        },
        SZ: {
            Code:         'SZ',
            CurrentValue: '0000',
        },
        VAR_ABM: {
            Code:         'VAR_ABM',
            CurrentValue: '0',
        },
        EA12: {
            Values: {
                Value: []
            }
        },
        EA34: {
            Values: {
                Value: []
            }
        },
        EA56: {
            Values: {
                Value: []
            }
        },
        EA78: {
            Values: {
                Value: []
            }
        },
        SB: {
            Code: 'SB',
            CurrentValue: '0',
        },
        SH: {
            Code: 'SH',
            CurrentValue: '0',
        },
        MISSING_AG: {
            Code: 'MISSING_AG',
            CurrentValue: '0'
        },
        MISSING_GP: {
            Code: 'MISSING_GP',
            CurrentValue: '0'
        }
    },

    WT: {

        WT_TIEFE: {
            Code:         'W_TIEFE',
            CurrentValue: '0',
        },
        BREITE: {
            Code:         'BREITE',
            CurrentValue: '0',
            LowerLimit:   '0',
            UpperLimit:   '0',
        },
        TIEFE: {
            Code:         'TIEFE',
            CurrentValue: '0',
            LowerLimit:   '0',
            UpperLimit:   '0',
        },
        VAR_ABM: {
            Code:         'VAR_ABM',
            CurrentValue: '0',
        },

        MISSING_WT_ALAZ_checkbox: {
            Code:         'MISSING_WT_ALAZ_checkbox',
            CurrentValue: '0',
        },

        WT_ALAZ: {
            Code:         "WT_ALAZ",
            CurrentValue: '0',
            Values:       {
                Value: [
                    {
                        Description: ['kein', 'sans', 'without', 'senza'],
                        Code:        '0',
                    },
                    {
                        Description: ['1 Loch', '', '', ''],
                        Code:        '1',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '2',
                    },
                ],
            },
        },

        // WT_ALAZ: {
        //     Code: "WT_ALAZ",
        //     CurrentValue: '0'
        // },

        WT_ALP1: {
            Code:         'WT_ALP1',
            CurrentValue: '00',
            Values:       {
                Value: [
                    {
                        Description: ['kein', 'sans', 'without', 'senza'],
                        Code:        '00',
                    },
                    {
                        Description: ['1 Loch', '', '', ''],
                        Code:        '01',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '02',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '03',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '06',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '07',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '23',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '67',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '99',
                    },
                ],
            },
        },

        // WT_ALP1: {
        //     Code: 'WT_ALP1',
        //     CurrentValue: '00'
        // },

        WT_ALP2: {
            Code:         'WT_ALP2',
            CurrentValue: '00',
            Values:       {
                Value: [
                    {
                        Description: ['kein', 'sans', 'without', 'senza'],
                        Code:        '00',
                    },
                    {
                        Description: ['1 Loch', '', '', ''],
                        Code:        '01',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '02',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '03',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '06',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '07',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '23',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '67',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '99',
                    },
                ],
            },
        },


        // WT_ALP2: {
        //     Code: 'WT_ALP2',
        //     CurrentValue: '00'
        // },

        WT_ALS: {
            Code:         'WT_ALS',
            CurrentValue: '00',
            Values:       {
                Value: [
                    {
                        Description: ['kein', '', '', ''],
                        Code:        '00',
                    },
                    {
                        Description: ['3-Loch-Armatur', '', '', ''],
                        Code:        '01',
                    },
                    {
                        Description: ['Rundlochbohrung nach Mass (gem. Skizze)', '', '', ''],
                        Code:        '02',
                    },
                    {
                        Description: ['Sonder', '', '', ''],
                        Code:        '99',
                    },
                ],
            },
        },

        MISSING_WT_ALS_checkbox: {
            Code:         'MISSING_WT_ALS_checkbox',
            CurrentValue: '0',
        },

        WT_ALS_T: {
            Code:         'WT_ALS_T',
            CurrentValue: '',
        },

        SSP: {
            Code:         'SSP',
            CurrentValue: '00',
            Values:       {
                Value: [
                    {
                        Description: ['kein', 'sans', 'without', 'senza'],
                        Code:        '00',
                    },
                    {
                        Description: ['1 Loch', '', '', ''],
                        Code:        '01',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '02',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '03',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '06',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '07',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '23',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '67',
                    },
                    {
                        Description: ['2 Loch',  '',  '', ''],
                        Code:        '99',
                    },
                ],
            },
        },

        STP: {
            Code:         'STP',
            CurrentValue: '00',
            Values:       {
                Value: [
                    {
                        Description: ['kein', 'sans', 'without', 'senza'],
                        Code:        '00',
                    },
                ],
            },
        },

        MISSING_SSPV_checkbox: {
            Code:         'MISSING_SSPV_checkbox',
            CurrentValue: '0',
        },

        SSPV: {
            Code:         'SSPV',
            CurrentValue: '0',
        },

        MISSING_STV: {
            Code:         'MISSING_STV',
            CurrentValue: '0',
        },

        MISSING_HTHV: {
            Code:         'MISSING_HTHV',
            CurrentValue: '0',
        },

        ST: {
            Code:         'ST',
            CurrentValue: '0',
        },
        STV: {
            Code:         'STV',
            CurrentValue: '0',
        },

        HTH: {
            Code:         'HTH',
            CurrentValue: '0',
        },

        HTHV: {
            Code:         'HTHV',
            CurrentValue: '0',
        },

        KTSV: {
            Code:         'KTSV',
            CurrentValue: '0',
        },

        MISSING_KTSV_checkbox: {
            Code:         'MISSING_KTSV_checkbox',
            CurrentValue: '0',
        },

        UL: {
            Code: 'UL'
        },

        UL_inverter: {
            Code: 'UL_inverter',
            CurrentValue: '0'
        },
    },

    KRW: {
        SK23_switch: {
            Code: 'SK23_switch',
            CurrentValue: '0',
        },
        SK23_activator: {
            Code: 'SK23_activator',
            CurrentValue: '0',
        },
        SK45_switch: {
          Code: 'SK45_switch',
          CurrentValue: '0',
        },
        SK45_activator: {
          Code: 'SK45_activator',
          CurrentValue: '0',
        },
        SK67_switch: {
            Code: 'SK67_switch',
            CurrentValue: '0',
        },
        SK67_activator: {
            Code: 'SK67_activator',
            CurrentValue: '0',
        },
        SK81_switch: {
            Code: 'SK81_switch',
            CurrentValue: '0',
        },
        SK81_activator: {
            Code: 'SK81_activator',
            CurrentValue: '0'
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/initialState.js